import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITransactionCoordinatorCatalogue } from "../../types/transaction-coordinator";

export interface CatalogueState {
    loading: boolean;
    loadingError: string;
    catalogues: ITransactionCoordinatorCatalogue[];
}

const initialState: CatalogueState = {
    loading: false,
    loadingError: "",
    catalogues: []
};

const catalogueSlice = createSlice({
    name: "catalogue",
    initialState,
    reducers: {
        setCatalogueLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setCatalogueLoadingError: (state, action: PayloadAction<string>) => {
            state.loadingError = action.payload;
        },
        populateCatalogues: (state, action: PayloadAction<ITransactionCoordinatorCatalogue[]>) => {
            state.catalogues = [...action.payload];
        },
        addCatalogue: (state, action: PayloadAction<ITransactionCoordinatorCatalogue>) => {
            state.catalogues.push(action.payload);
        }
    }
});

export const selectCatalogues = (state: { catalogue: CatalogueState }) =>
    state.catalogue.catalogues;

// Export actions
export const { setCatalogueLoading, setCatalogueLoadingError, populateCatalogues, addCatalogue } =
    catalogueSlice.actions;

export default catalogueSlice.reducer;
